<template>
  <div class="tunnel-container">
    <!-- 右侧表单区域 -->
    <div class="form-card">
      <div class="form-title">在线留言</div>
      <el-form 
        :model="form" 
        :rules="rules" 
        ref="formRef"
        label-width="80px"
        label-position="top"
        class="message-form"
      >
        <el-row :gutter="15">
          <!-- 姓名 -->
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <!-- 手机号 -->
          <el-col :span="12">
            <el-form-item label="手机号" prop="phoneNumber">
              <el-input v-model="form.phoneNumber" placeholder="请输入正确的手机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 邮箱 -->
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容" prop="content">
          <el-input 
            v-model="form.content" 
            type="textarea" 
            rows="4" 
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item label="验证码" prop="code">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-input v-model="form.code" placeholder="请输入验证码"></el-input>
            </el-col>
            <el-col :span="12" class="code-img">
              <div class="identify-box" @click="refreshCode">
                 <img :src="codeUrl" alt="验证码" />
              </div>
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 按钮 -->
        <el-form-item class="btn-group">
          <el-button type="primary" @click="onSubmit">提交</el-button>
          <el-button @click="resetForm">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "TunnelMessageForm",
  data() {
    return {
      codeUrl: "",
      form: {
        name: "",
        phoneNumber: "",
        email: "",
        content: "",
        code: "",
        captchaId: ""
      },
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phoneNumber: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "手机号格式错误", trigger: "blur" }
        ],
        email: [
          { required: false, message: "请输入邮箱", trigger: "blur" },
          { pattern: /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "邮箱格式错误", trigger: "blur" }
        ],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      }
    };
  },
  mounted() {
    this.refreshCode()
  },
  methods: {
    // 更新验证码
    refreshCode() {
      this.$fetch("/api/Message/GenerateValidCode")
        .then(res => {
          this.form.code = ""
          this.form.captchaId = res.data.captchaId
          this.codeUrl = `data:image/png;base64,${res.data.image}`
        })
        .catch(err => {
          throw err;
        });
    },
    // 重置表单
    resetForm() {
      this.$refs.formRef.resetFields();
      this.refreshCode();
    },
    // 提交
    _getSubmit() {
      this.$post("/api/Message/Submit", this.form)
        .then(res => {
          if(!res.data.isSuccessed) {
            this.$message.error(res.data.errorMessage);
            this.refreshCode()
            return
          }

          this.$message.success("提交成功！");
          this.resetForm();
        })
        .catch(err => {
          throw err;
        });
    },
    // 提交表单
    onSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this._getSubmit();
        } else {
          this.$message.error("请完善表单信息");
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
/* 页面容器 */
.tunnel-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background: url("../../assets/img/bg_online-message.png") no-repeat center center;
  background-size: 100% 100%;
}

/* 右侧表单卡片 */
.form-card {
  position: absolute;
  top: 50%;
  right: 80px;
  transform: translateY(-50%);
  width: 750px;
  height: auto;
  max-height: 665px;
  padding: 3% 5%;
  background: #fff;
  z-index: 10;
  box-sizing: border-box;
  box-shadow: 0px 0px 40px 0px rgba(15,26,20,0.4);
  border-radius: 20px;
}

/* 表单标题 */
.form-title {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  font-size: 36px;
  color: #0078D7;
  line-height: 42px;
}

/* 表单样式 */
.message-form {
  width: 100%;
}

.el-form-item {
  margin-bottom: 7px;
}

.el-form-item:last-child {
  margin-bottom: 0;
  margin-top: 10px;
}

/* 表单输入框样式 */
/deep/ .el-form-item__label {
  color: #999999;
  padding: 0 !important;
}

/deep/ .el-input__inner {
  border: none;
  border-radius: 8px;
  background: #EBEFF2;
}

/deep/ .el-textarea__inner {
  border: none;
  border-radius: 8px;
  background: #EBEFF2;
}

/* 验证码区域 */
.code-img {
  line-height: 40px;
  user-select: none;
}

.identify-box {
  display: inline-block;
  width: 112px;
  height: 40px;
  cursor: pointer;
}

.identify-box img {
  height: 40px;
  width: auto;
}

/* 按钮组 */
.btn-group {
  text-align: center;
  margin-top: 10%;
}

.btn-group .el-button {
  width: 150px;
  margin: 0 8px;
}

.el-button--primary {
  background-color: #0078D7;
  border-color: #0078D7;
}

/* 响应式适配 - 屏幕宽度小于768px时调整表单位置 */
@media (max-width: 768px) {
  .form-card {
    width: 90%;
    right: 5%;
    top: 50px;
    transform: none;
    margin-bottom: 50px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/OnlineMessage/OnlineMessage.vue